var CarouselVariants;
(function (CarouselVariants) {
    CarouselVariants["Swipe"] = "Swipe";
    CarouselVariants["FadeInOut"] = "FadeInOut";
})(CarouselVariants || (CarouselVariants = {}));
var ButtonPlacements;
(function (ButtonPlacements) {
    ButtonPlacements["Overlay"] = "Overlay";
    ButtonPlacements["Overhang"] = "Overhang";
})(ButtonPlacements || (ButtonPlacements = {}));

export { ButtonPlacements, CarouselVariants };
